import { SeMappableModel } from 'se-fe-service';

export interface DiscountRequirements {
  requirement_type: string;
  application_value: number;
}

export interface DiscountBenefits {
  max_eligible_items: number | null;
  discount_type: string;
  discount_value: number;
  max_dollar_amount: number;
}

export interface DiscountApiResponse {
  available_count: number;
  benefits: DiscountBenefits;
  buyx_gety: boolean;
  code_count: number;
  code_max_usage: string;
  created_at: string;
  currency_symbol: string;
  discount_scope: string;
  discount_style: string;
  discount_type: string;
  discount_value: string;
  discounted_item_variation_ids: number[] | null;
  discounted_items: any;
  expires_at: string | null;
  id: number;
  max_eligible_items: number | null;
  max_use_count: number | null;
  maximum_discount_value: string;
  maximum_discount_value_cents: number | null;
  minimum_sale_total: string;
  minimum_sale_total_cents: number;
  name: string;
  promotion?: any;
  required_item_variation_ids: number[] | null;
  required_items: any;
  required_items_quantity: number | null;
  requirement_type: string;
  requirements: DiscountRequirements;
  single_use: boolean;
  starts_at: string;
  status: string;
  store_id: number;
  supplied_code: string;
  used_code_count: number;
}

export class Discount extends SeMappableModel implements DiscountApiResponse {
  available_count: number;
  benefits: DiscountBenefits;
  buyx_gety: boolean;
  code_count: number;
  code_max_usage: string;
  created_at: string;
  currency_symbol: string;
  discount_scope: string;
  discount_style: string;
  discount_type: string;
  discount_value: string;
  discounted_item_variation_ids: number[];
  discounted_items: string | number[];
  expires_at: string;
  id: number;
  max_eligible_items: number;
  max_use_count: number | null;
  maximum_discount_value: string;
  maximum_discount_value_cents: number;
  minimum_sale_total: string;
  minimum_sale_total_cents: number;
  name: string;
  required_item_variation_ids: number[] | null;
  required_items: string | number[];
  required_items_quantity: number;
  requirement_type: string;
  requirements: DiscountRequirements;
  single_use: boolean;
  starts_at: string;
  status: string;
  store_id: number;
  supplied_code: string;
  used_code_count: number;
  sale_id: number;

  // JMB [2026-02-18]: These fields are not returned by the API but are needed
  // for the UI, so we add them to the model.
  additional_code_count: string;
  max_use: string;
  organization_id: string;
  sale_number: string;
  sale_type: string;
}
